import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button1Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M0 0H5V10H0V0ZM0 11H17L11.7241 16V21H5.86207V16L0 11ZM17 0H12V10H17V0Z" />
  </SvgIcon>
);

export default PO28Button1Icon;
